import { render, staticRenderFns } from "./EditProfileDialog.vue?vue&type=template&id=0487ddae&scoped=true"
import script from "./EditProfileDialog.vue?vue&type=script&lang=js"
export * from "./EditProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./EditProfileDialog.vue?vue&type=style&index=0&id=0487ddae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487ddae",
  null
  
)

export default component.exports